<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Site User Mapping
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">User<span class="text-danger">*</span></label>
                <ng-select name="usermaster" [items]="UserMaster" bindLabel="UserName" bindValue="UserMasterId"
                    [(ngModel)]="UserId" (change)="ComboLoad('BranchUserRight');onChange('User');clear()"
                    placeholder="Select User">
                </ng-select>
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)="ComboLoad('ClientUserRight');onChange('Branch');clear()"
                    placeholder="Select Branch">
                </ng-select>
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId" placeholder="Select Client" (change)="clear()">
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            &nbsp;&nbsp;<div class="col-md-1 px-1"><br>
                <input class="form-check-input" style="height: 16px; width: 16px;" name="filter" type="checkbox"
                    value="" [(ngModel)]="AllClient" (change)="clear()" />&nbsp;&nbsp;<label style="font-size: 14px;">All Client
                </label>
            </div>
            <div class="col"><br>
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Load()">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <hr>
        <div class="row m-1">
            <div class="col"></div>
            <div class="col-md-2">
                <input name="search" type="text" class="form-control" placeholder="Search" [(ngModel)]="searchTerm"
                    [disabled]="Site.length <= 0" />
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                    (click)="highlightAndScroll()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div><br>
        </div>
        <div>
            <div class="row m-1">
                <div class="form-group">
                    <div class="row">
                        <div class="col">
                            <label class="Label">Site</label>
                        </div>
                        <div class="col-auto"><button type="button"
                                *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit"
                                class="btn btn-sm btn-primary" [disabled]="isDisabled" name="ExportExcel"
                                (click)="ExportExcel()">
                                <i class="bi bi-download" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Export Excel':'Loading...'}}
                            </button></div>
                    </div>

                    <select class="form-select form-control height" aria-label="Site" title="Site" name="Sites"
                        [(ngModel)]="selectedSiteIds" [multiple]="true" required>
                        <option *ngFor="let user of Site" [value]="user.SiteMasterID"
                            [ngClass]="{'highlight': selectedSiteIds.includes(user.SiteMasterID)}">
                            {{ user.SiteName }}
                        </option>
                    </select>
                </div>
            </div><br>
            <div class="row m-1 justify-content-center">
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                        (click)="onSiteClick('siteToAssign')">
                        <i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                    </button>
                    &nbsp;&nbsp;<button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                        (click)="onSiteClick('assignToSite')">
                        <i class="bi bi-caret-up-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                    </button>
                    &nbsp;&nbsp;<button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                        (click)="onSiteClick('siteToAssignAll')">
                        <i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i><i class="bi bi-caret-down-fill"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                    </button>
                    &nbsp;&nbsp;<button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled"
                        (click)="onSiteClick('assignToSiteAll')">
                        <i class="bi bi-caret-up-fill" *ngIf="!isDisabled"></i><i class="bi bi-caret-up-fill"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                    </button>
                </div>
            </div>
            <div class="row m-1">
                <div class="form-group">
                    <div class="row">
                        <div class="col">
                            <label class="Label">User Assigned Sites<span class="text-danger">*</span></label>
                        </div>
                        <input id="file-upload" type="file" style="display: none"
                            (change)="handleFileInputChange($event)" accept=".xlsx,.xls,.csv">
                        <div class="col-auto">
                            <label for="file-upload" role="button"
                                *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit"
                                class="btn btn-sm btn-primary" name="UploadExcel" for="file-upload">
                                <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Upload Excel':'Loading...'}}
                            </label>
                        </div>
                    </div>
                    <select class="form-select form-control height" aria-label="Site" title="Site" name="Sites"
                        [(ngModel)]="selectedassignedSitesIds" [multiple]="true" required>
                        <option *ngFor="let user of UserAssignedSite" [value]="user.SiteMasterID">
                            {{ user.SiteName }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" *ngIf="this.common.PageRight.IsAdd || this.common.PageRight.IsEdit"
                    class="btn btn-sm btn-primary" [disabled]="isDisabled" name="save" (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                &nbsp;&nbsp;<button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" name="Reset"
                    (click)="Reset()">
                    <i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reset':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>